// const IMAGE_API = `https://villa-images-sg.s3-accelerate.amazonaws.com/imageBySku/`;
const IMAGE_FULL_API = `https://d19oj5aeuefgv.cloudfront.net/`;
const IMAGE_ORIGINAL_FULL_API = `https://villa-remove-bg-input.s3-ap-southeast-1.amazonaws.com/`;
const IMAGE_THUMBNAIL_API = `https://d1vl5j0v241n75.cloudfront.net/`;
const IMAGE_THUMBNAIL_ORIGINAL_API = `https://villa-remove-bg-input.s3-ap-southeast-1.amazonaws.com/`;

export function getProductImageURL(sku, original) {
    if (sku) {
        const padded = sku.toString().padStart(7, "0");
        if (original) {
            return IMAGE_ORIGINAL_FULL_API + padded;
        }
        return IMAGE_FULL_API + padded;
    }
    return null;
}

export function getProductImageThumbnail(sku, original) {
    if (sku) {
        const padded = sku.toString().padStart(7, "0");
        if (original) {
            return IMAGE_THUMBNAIL_ORIGINAL_API + padded;
        }
        return IMAGE_THUMBNAIL_API + padded;
    }
    return null;
}
